module.exports = __webpack_public_path__ + "img/no-hay-noticias.f2ac9f80.png";